import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MathE } from '../../../../shared/helper/MathExtension';
import { gameStore } from '../../../stores/GameStore';
const center = 1280 / 2;
const backgroundWidth = 606;
const indicatorWidth = 23;
const barLength = 392;
const ReputationIndicatorBackground = styled.img.withConfig({
  displayName: "ReputationIndicatorUI__ReputationIndicatorBackground",
  componentId: "sc-1hord3h-0"
})(["position:absolute;top:0px;left:", "px;pointer-events:none;"], center - backgroundWidth / 2);
const ReputationIndicator = styled.img.withConfig({
  displayName: "ReputationIndicatorUI__ReputationIndicator",
  componentId: "sc-1hord3h-1"
})(["z-index:1;position:absolute;top:14px;transition-property:top right;transition-duration:2s;pointer-events:none;"]);
const labelDistanceX = "878px";
const labelDistanceFromTop = "1px";
const Label = styled.div.withConfig({
  displayName: "ReputationIndicatorUI__Label",
  componentId: "sc-1hord3h-2"
})(["position:absolute;top:", ";pointer-events:none;font-size:85%;"], labelDistanceFromTop);
const WindChasersLabel = styled(Label).withConfig({
  displayName: "ReputationIndicatorUI__WindChasersLabel",
  componentId: "sc-1hord3h-3"
})(["left:", ";transform:translateX(-50%);"], labelDistanceX);
const SilverAnchorsLabel = styled(Label).withConfig({
  displayName: "ReputationIndicatorUI__SilverAnchorsLabel",
  componentId: "sc-1hord3h-4"
})(["right:", ";transform:translateX(50%);"], labelDistanceX);
const ReputationRank = styled.div.withConfig({
  displayName: "ReputationIndicatorUI__ReputationRank",
  componentId: "sc-1hord3h-5"
})(["position:absolute;top:34px;left:0px;right:0px;text-align:center;pointer-events:none;font-size:70%;"]);
export const ReputationIndicatorUI = observer(() => {
  var _gameStore$gameEngine;

  const {
    t
  } = useTranslation();
  const {
    gameState
  } = gameStore.gameEngine;
  const reputationStatus = (_gameStore$gameEngine = gameStore.gameEngine.getCachedActionNode(gameState.playerReputationStatus)) === null || _gameStore$gameEngine === void 0 ? void 0 : _gameStore$gameEngine.status;
  console.log(gameState.playerReputationSilverAnchors, gameState.playerReputationWindChasers);
  const pos = MathE.clamp((gameState.playerReputationSilverAnchors - gameState.playerReputationWindChasers) / 85, -1, 1);
  const left = center - indicatorWidth / 2 + pos * (barLength / 2) + "px";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReputationIndicator, {
    src: "assets/game/images/UI/reputation_marker.png",
    style: {
      left
    }
  }), /*#__PURE__*/React.createElement(ReputationIndicatorBackground, {
    src: "assets/game/images/UI/reputation_background.png"
  }), /*#__PURE__*/React.createElement(WindChasersLabel, null, "Windchaser"), /*#__PURE__*/React.createElement(SilverAnchorsLabel, null, "Silver Anchors"), /*#__PURE__*/React.createElement(ReputationRank, null, reputationStatus ? reputationStatus.get(gameStore.languageKey) : t("content.reputation_rank_newcomer")));
});